import React from "react";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import WhatsAppInstance from "./WhatsAppInstance";
import WhatsAppQueue from "./WhatsAppQueue";
import WhatsAppLogs from "./WhatsAppLogs";
import WhatsAppQuickReplies from "./WhatsAppQuickReplies";

const WhatsAppSettings = () => {
  const tabItems = [
    {
      text: "WhatsApp Instance",
      component: <WhatsAppInstance />,
      slug: "whatsappgroup/instances",
    },
    {
      text: "WhatsApp Queue",
      component: <WhatsAppQueue />,
      slug: "whatsappgroup/queue",
    },
    {
      text: "Quick Replies",
      component: <WhatsAppQuickReplies />,
      slug: "whatsappgroup/quick-replies",
    },
    {
      text: "Logs",
      component: <WhatsAppLogs />,
      slug: "whatsappgroup/logs",
    },
  ];

  return (
    <PageShell title="WhatsApp Management">
      <TabsNavigator tabItems={tabItems} pageSlug="whatsappgroup" />
    </PageShell>
  );
};

export default WhatsAppSettings;
